module.exports = __webpack_public_path__ + "img/lock.5807202d.png";